import { EVENTS } from '@apps/web/lib/events';

export type MessageSurface = 'extension' | 'web';

type PostHogLike = {
    readonly capture: (
        event: string,
        properties: Record<string, unknown>,
    ) => void;
};

// The Chrome extension passes clientSurface="extension"; the web general
// sidebar passes null. Everything else is treated as the web surface.
export function resolveMessageSurface(
    clientSurface: string | null | undefined,
): MessageSurface {
    return clientSurface === 'extension' ? 'extension' : 'web';
}

// Emits the message-sent analytics event tagged with the surface (extension vs
// web sidebar) so message volume can be compared per surface. Mirrors the
// backend `client_surface` run tag. A no-op when PostHog is not initialized
// (e.g. local dev), matching the guarded `posthog?.capture` call site.
export function captureConversationMessageSent(
    posthog: PostHogLike | null | undefined,
    params: {
        readonly clientSurface: string | null | undefined;
        readonly conversationId: string | null | undefined;
        readonly draftLength: number;
        readonly mode: string | undefined;
        readonly organizationId: string | null;
    },
): void {
    posthog?.capture(EVENTS.CONVERSATION_MESSAGE_SENT, {
        composer: 'phoebe_chat_view',
        conversation_id: params.conversationId ?? undefined,
        draft_length: params.draftLength,
        mode: params.mode,
        organization_id: params.organizationId,
        surface: resolveMessageSurface(params.clientSurface),
    });
}
